module.exports = __webpack_public_path__ + "static/media/icon-box.4fc3082c.svg";